import React from 'react';
import { SingleTradeInFormProvider } from './TradeInFormProvider';
import { TradeInForm } from './TradeInForm';
import { useLienholderFormData } from '../hooks/useLienholderFormData';

type SingleTradeInWrapperProps = {
    formIndex: number;
    isEditDisabled: boolean;
    isTradeInFormDirtyRef?: React.MutableRefObject<boolean>;
    onContractingErrorsAlert?: (hasErrors: boolean) => void;
};

export const SingleTradeInWrapper = ({
    formIndex,
    isEditDisabled,
    isTradeInFormDirtyRef,
    onContractingErrorsAlert
}: SingleTradeInWrapperProps) => {
    const { lienholderData, setLienholderData } = useLienholderFormData(formIndex, isEditDisabled === true);

    return (
        <SingleTradeInFormProvider tradeInIndex={formIndex} onContractingErrorsAlert={onContractingErrorsAlert}>
            <TradeInForm
                isEditDisabled={isEditDisabled}
                lienholderData={lienholderData}
                setLienholderData={setLienholderData}
                isTradeInFormDirtyRef={isTradeInFormDirtyRef}
            />
        </SingleTradeInFormProvider>
    );
};
